module.exports = __webpack_public_path__ + "img/course_005.ed03643.png";